import { Toaster as SonnerToaster, toast as sonnerToast } from 'sonner';
import styles from './Toast.module.css';

export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      richColors={false}
      closeButton
      toastOptions={{
        classNames: {
          toast: styles.toast,
          title: styles.title,
          description: styles.description,
          actionButton: styles.actionBtn,
          cancelButton: styles.cancelBtn,
          closeButton: styles.closeBtn,
          success: styles.success,
          error: styles.error,
          warning: styles.warning,
          info: styles.info,
        },
      }}
    />
  );
}

export const toast = sonnerToast;
